'use strict';

import Loading from '../components/Loading';
import SearchRequest from "../components/SearchRequest";
import SearchFooter from "../components/SearchFooter";
import SearchResults from "../components/SearchResults";
import SearchFilter from "../components/SearchFilter";
import SearchTiming from "../components/SearchTiming";
import SearchNoResults from "../components/SearchNoResults";
import SearchCompare from "../components/SearchCompare";
import SearchError from "../components/SearchError";
import BannerCreateRequest from "../components/BannerCreateRequest";
import SearchRoutes from "../components/SearchRoutes";
import {hasCities, queryGetActualSearchData, replaceCityToAirport} from "../helpers/search";
import SearchSwitchTriple from "../components/SearchSwitchTriple";

class SearchContainer extends React.Component {
    constructor(props) {
        super(props);

        this.abortController = new AbortController();
        this.state = {
            isPlanesFetching: false,
            isSeatsFetching: false,
            isToursFetching: false,
            searchPerformed: false,
            serverErrorTag: undefined,
            type: 'planes',
            airports: [],
            classes: [],
            additional: [],
            prices: {},

            routesPlane: [{
                from: {},
                to: {},
                date: '',
                time: '',
                seats: 0,
            }],

            routesSeats: [{
                from: {},
                to: {},
                date: '',
                time: '',
                seats: 0,
            }],

            filters: {br: true, pl: true, el: true, st: true, js: true, dl: true, dc: true},
            counters: {br: 0, pl: 0, el: 0, st: 0, js: 0, dl: 0, dc: 0, tours: 0},
            planes: [],
            seats: [],
            tours: [],
            timing: [],
            barometer: null,
            
            seatsAnchor: null,
            toursCountry: null,
        };

        this.handleChangeType = this.handleChangeType.bind(this)
        this.handleChangeRoutes = this.handleChangeRoutes.bind(this)
        this.handleSetFilter = this.handleSetFilter.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }

    componentDidMount() {
        
        this.init();
        
        const initQueryParams = async () => {
            
            const querySearchData = await queryGetActualSearchData(true)
            const reactSearchData = storageGetActualSearchData();

            if (querySearchData && querySearchData.length > 0) {

                this.setState({
                    routesPlane: querySearchData,
                    routesSeats: querySearchData,
                }, () => {
                    this.handleSearch();
                });
            } else {
                storageRemove('reactSearchData');
                const searchOnMount = Object.keys(reactSearchData).length > 0;
                if(searchOnMount) {
                    this.setLinksData(reactSearchData.routesPlane);
                    this.setState({
                        // type: reactSearchData.type || this.state.type,
                        routesSeats: reactSearchData.routesSeats || this.state.routesSeats,
                        routesPlane: reactSearchData.routesPlane || this.state.routesPlane,
                        searchPerformed: true,
                    }, () => {
                        this.handleSearch();
                    });
                }
            }
        }

        initQueryParams();
    }

    init() {
        requestAction.initData().then(response => {
            this.setState({
                airports: response.airports,
                classes: response.classes,
                additional: response.additional,
            })
        })
    }

    handleChangeType(type) {
        this.setState({type});
    }

    handleChangeRoutes(routes, search = false) {

        let routesPlane = hasCities(routes) ? replaceCityToAirport(routes) : routes;
        let routesSeats = routes;
        
        this.setLinksData(routesPlane)

        this.setState({
            routesPlane: routesPlane,
            routesSeats: routesSeats,
        }, () => {
            if (search)
                this.handleSearch();
        })
    }
    
    setLinksData(routes) {
        const seatsAnchor = [parseInt(routes[0]['from']['city_id']), parseInt(routes[0]['to']['city_id'])]
            .filter(e => e)
            .sort((a, b) => a - b)
            .join('-');
        const toursCountry = routes[0]['to']['country_id'] || null;

        this.setState({
            seatsAnchor: seatsAnchor,
            toursCountry: toursCountry,
        })
    }

    handleSetFilter(filter, value) {
        const {filters} = this.state;
        this.setState({filters: {
            ...filters,
            [filter]: value,
        }})
    }

    handleCreateRequest() {
        location.href = '/request/plane?from_search=1';
    }
    
    resetSearchResults()
    {
        this.setState ( {
            planes: [],
            seats: [],
            counters: {br: 0, pl: 0, el: 0, st: 0, js: 0, dl: 0, dc: 0, tours: 0},
            timing: [],
        } )
    }
    
    getRoutesByType(type = null) {
        const {type: stateType, routesPlane, routesSeats} = this.state;
        type = type || stateType;
        return type === 'seats' ? routesSeats : routesPlane;
    }
    
    setStorageAfter() {
        const {type, routesPlane, routesSeats, barometer} = this.state;
        
        const items = this.getCombinedEqualItemsAndCounters()
        
        storageSet('reactSearchData', {
            type, 
            routesPlane, 
            routesSeats,
            
            seatsAnchor: this.state.seatsAnchor,
            toursCountry: this.state.toursCountry,
            
            planesCount: this.getPlanesCount(items.counters),
            seatsCount: this.getSeatsCount(),
            toursCount: this.getToursCount(),
        })
    }
    
    setSeatsCount() {
        storageAdd('reactSearchData', {
            seatsCount: this.getSeatsCount(),
        })
    }
    
    setToursCount() {
        storageAdd('reactSearchData', {
            toursCount: this.getToursCount(),
        })
    }

    handleSearch() {
        const {type, routesPlane, routesSeats, barometer, seatsAnchor, toursCountry} = this.state;
        
        if(!this.validate()) return;
        
        storageSet('reactSearchData', {type, routesPlane, routesSeats, seatsAnchor, toursCountry})
        
        this.resetSearchResults();
        this.setState({ isPlanesFetching: true, isSeatsFetching: true, isToursFetching: true, serverErrorTag: undefined, searchPerformed: true });
        this.abortController.abort();
        this.abortController = new AbortController();
        const abortSignal = this.abortController.signal;
        
        if (feature_enabled('FEATURE_SEARCH_BY_CURSOR')) {
            const allCounters = new Map();
            const requestUUID = uuidv4()
            const fetch = ( type, routes, abortSignal ) => {
                return new Promise((resolve, reject) => {
                    searchAction.fetchStream({
                        onData: ( { items, counters, payload }, request ) => {
                            this.setState((state) => {
                                const currentItems = [ ...state[request.type] ].filter(e => e._cursor !== request.id );

                                for ( const item of items )
                                {
                                    const found = currentItems.find( e => e.id === item.id )
                                    if (found) continue
                                    currentItems.push( { ...item, _cursor: request.id } )
                                }

                                allCounters.set(request.id, counters)

                                const totalCounters = [...allCounters.values()]
                                    .reduce ( ( total, counters ) =>
                                    {
                                        return Object.entries(counters).reduce((a, [ key, value]) => ({ ...a, [ key ]: ( a[ key ] || 0 ) + value }), total)
                                    }, { br: 0, pl: 0, el: 0, st: 0, js: 0, dl: 0, dc: 0 } );
                                
                                // Сейчас обработчик seats только один, поэтому просто перезаписываем state
                                const totalTiming = payload.timing ? payload.timing : state.timing;
                                const totalPrices = payload.prices ? payload.prices : state.prices;

                                return {
                                    [request.type]: currentItems,
                                    counters: totalCounters,
                                    timing: totalTiming,
                                    prices: totalPrices,
                                }
                            })
                        },
                        onError: ( error ) => {
                            this.setState({ serverErrorTag: error.message });
                            return reject();
                        },
                        onClose: ( cancelled ) => {
                            if (cancelled)
                                return reject();

                            this.setState(_ => {}, resolve); // Чтобы выполнилось только после записи в стэйт последнего фетча
                        },
                        abortSignal,
                    }, { type, routes, uuid: requestUUID })
                    
                })
            }

            const promises = []
            promises.push(
                fetch('planes', routesPlane, abortSignal)
                    .then(() => {
                        const combined = this.getCombinedEqualItemsAndCounters();
                        const resultsCount = this.getPlanesCount(combined.counters)
                        searchAction.fetchBarometer({routes: routesPlane}).then(response => {
                            this.setState({
                                barometer: !!response ? response : barometer,
                            })
                        })
                        searchAction.saveStatistics({uuid: requestUUID, type: 'planes', results_count: resultsCount, routes: routesPlane});
                    })
                    .finally(() => !abortSignal.aborted && this.setState({isPlanesFetching: false}))
                ,
                fetch('seats', routesPlane, abortSignal)
                    .then(() => {
                        // const combined = this.getCombinedEqualItemsAndCounters();
                        // const resultsCount = this.getSeatsCount(combined.counters)
                        // searchAction.saveStatistics({ type: 'seats', results_count: resultsCount, routes: routesSeats})
                    })
                    .finally(() => {
                        if (abortSignal.aborted) return;
                        this.setState({isSeatsFetching: false})
                        this.setSeatsCount();
                    })
                ,
                fetch('tours', routesPlane, abortSignal)
                    .then(() => {
                        // const combined = this.getCombinedEqualItemsAndCounters();
                        // const resultsCount = this.getToursCount(combined.counters)
                    })
                    .finally(() => {
                        if (abortSignal.aborted) return;
                        this.setState({isToursFetching: false})
                        this.setToursCount();
                    })
            )
            
            Promise.allSettled(promises)
                .then(() => {
                    this.setStorageAfter()
                })
        } 
        else 
        {
            const routes = this.getRoutesByType();
            let request = {type, routes};
            this.fetchItems({...request, callback: (response) => {
                    const {counters} = response;
                    this.setState(() => {
                        const state = {}
                        if (request.type === 'planes') {
                            state.isPlanesFetching = false
                        }
                        if (request.type === 'seats') {
                            state.isSeatsFetching = false
                        }
                        if (request.type === 'tours') {
                            state.isToursFetching = false
                        }
                        
                        return state
                    })
                    const results_count = Object.values(counters).reduce((a, b) => a + b, 0);
                    searchAction.saveStatistics({type: request.type, results_count, routes})
                    request.type = request.type === 'planes' ? 'seats' : 'planes';
                    request.routes = this.getRoutesByType(request.type)
                    this.fetchItems({ ...request });
                }});
        }
    }

    validate() {
        const {type, routesPlane, routesSeats} = this.state;
        let validated = true
        validated = validated && this.validateByType(type, routesPlane)
        validated = validated && this.validateByType(type, routesSeats)
        return validated;
    }
    validateByType(type, routes) {
        let validated = true
        routes.map((route, index) => {
            if(!route.from.id) validated = false
            if(!route.to.id) validated = false
            if(!route.date) validated = false
            if(type === 'planes') {
                if (!route.time) validated = false
                if (!route.seats) validated = false
            }
        })
        return validated;
    }

    fetchItems({type, routes, callback = () => {}}) {
        const {counters, barometer, timing, prices} = this.state;
        searchAction.fetchItems({type, routes}).then(response => {
            this.setState({
                [type]: response.items,
                barometer: !!response.barometer ? response.barometer : barometer,
                timing: !!response.timing ? response.timing : timing,
                prices: type === 'seats' ? (!!response.prices ? response.prices : {}) : prices,
                counters: {
                    ...counters,
                    ...response.counters,
                }
            }, callback.bind(null, response))
        })
    }

    getPlanesCount(counters_filtered = null) {
        let {counters} = this.state;
        counters = counters_filtered || counters;
        return counters.pl + counters.br + counters.el;
    }

    getSeatsCount(counters_filtered = null) {
        let {counters} = this.state;
        counters = counters_filtered || counters;
        let count = counters.st + counters.js + counters.dl + counters.dc;
        return count > 0 ? 1 : 0;
    }
    
    getToursCount(counters_filtered) {
        let {counters} = this.state;
        counters = counters_filtered || counters;
        return counters.tours;
    }

    getFilteredItemsAndCounters() {
        const {type, filters} = this.state;
        const {planes, seats, counters} = this.getCombinedEqualItemsAndCounters();
        const isPlanes = type === 'planes';
        const allItems = isPlanes ? planes : seats;

        const items = allItems.filter(item => {
            let result = false;
            if(isPlanes) {
                if(counters.br && filters.br && item.type === 'barometer') result = true;
                if(counters.pl && filters.pl && item.type === 'plane') result = true;
                if(counters.el && filters.el && item.type === 'emptyleg') result = true;
            } else {
                if(counters.st && filters.st && item.type === 'shuttle') result = true;
                if(counters.js && filters.js && item.type === 'sharing') result = true;
                if(counters.dl && filters.dl && item.type === 'deal') result = true;
                if(counters.dc && filters.dc && item.discount) result = true;
            }
            return result;
        });

        return {items: (items.length === 0 ? allItems : items), counters};
    }
    
    getCombinedEqualItemsAndCounters() {

        // Если одинаковые equalityKey, то берем тот, у кого цена меньше
        
        const planes = [...this.state.planes];
        const seats = [...this.state.seats];
        const counters = {...this.state.counters};
        
        const filtered_planes = [];

        planes.map((item) => {

            const index = filtered_planes.findIndex((e) => e.equalityKey === item.equalityKey);

            // Если нет equalityKey или еще нет элемента в массиве
            if (!item.equalityKey || index === -1) {
                filtered_planes.push(item);
                return;
            }
            
            // Если уже есть элемент с equalityKey - отнимаем от каунтеров 1
            const counter_name = this.getCounterNameByType(item.type)
            if (counter_name)
                counters[counter_name] = Math.max(counters[counter_name] - 1, 0);
            
            // Если цена нового элемента меньше - заменяем
            if (filtered_planes[index].price > item.price)
                filtered_planes.splice(index, 1, item);
        });
        
        return {planes: filtered_planes, seats, counters};
    }
    
    getCounterNameByType (type) {
        switch (type) {
            case 'barometer': return 'br';
            case 'plane': return 'pl';
            case 'emptyleg': return 'el';
            case 'shuttle': return 'st';
            case 'sharing': return 'js';
            case 'deal': return 'dl';
            case 'discount': return 'dc';
            default: return null;
        }
    }

    getFilteredAirports() {
        const {type, airports} = this.state;
        return type === 'seats'
            ? airports
            : airports.filter(e => e.type !== 'city')
    }

    render() {
        const {isPlanesFetching, isSeatsFetching, isToursFetching, searchPerformed, serverErrorTag, type, timing, classes, additional, barometer, prices, filters} = this.state;
        const {items, counters} = this.getFilteredItemsAndCounters();
        const airports = this.getFilteredAirports();
        const routes = this.getRoutesByType();
        const noResults = items.length === 0;
        const hasResults = items.length > 0;
        
        const isFetching = type === 'planes' && isPlanesFetching || type === 'seats' && isSeatsFetching;

        return <div className="container">
            <SearchSwitchTriple
                type={type}
                planesCount={this.getPlanesCount(counters)}
                seatsCount={this.getSeatsCount(counters)}
                toursCount={this.getToursCount(counters)}
                setSearchScenario={searchPerformed && true}
            />
            <SearchRoutes
                type={type}
                routes={routes}
                airports={airports}
                onChangeRoutes={this.handleChangeRoutes}
                onSearch={this.handleSearch}
                onlyAirports={type !== 'seats'}
                isOpenedInit={!this.state.searchPerformed}
            />

            {serverErrorTag && <SearchError tag={serverErrorTag} onRetry={this.handleSearch}/>}

            {!serverErrorTag && <div>
                {!isFetching && <SearchCompare
                    type={type}
                    classes={classes.filter(item => item.show_in_barometer)}
                    barometer={barometer}
                />}
                {!isFetching && noResults && searchPerformed && <SearchNoResults
                    type={type}
                    timing={timing}
                />}
                <SearchTiming
                    type={type}
                    routes={routes}
                    timing={timing}
                    onSelect={routes => this.handleChangeRoutes(routes, true)}
                />
                {hasResults && <SearchFilter
                    type={type}
                    filters={filters}
                    counters={counters}
                    onSetFilter={this.handleSetFilter}
                />}

                {searchPerformed && <BannerCreateRequest
                    onClick={this.handleCreateRequest}
                />}

                {hasResults && <SearchResults
                    items={items}
                    routes={routes}
                />}
                <Loading
                    active={isFetching}
                    text={tMsg('Ищем для Вас варианты...')}
                />


                {!isFetching && hasResults && <SearchFooter/>}
                {!isFetching && noResults && <SearchRequest
                    type={type}
                    classes={classes.filter(item => item.show_in_request)}
                    additional={additional}
                    prices={prices}
                    routes={routes}
                />}
            </div>}
        </div>
    }
}

const domContainer = document.querySelector('#reactSearchContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(SearchContainer));
